<template>
  <div class="content">
    <div class="list">
      <el-row style="border-bottom: 1px solid #DCDCDC;margin-bottom: 18px;padding: 22px 0;">
        <el-col :span="12">
          <span style="color: #3D3D3D">数据字典列表</span>
        </el-col>
        <el-col style="display: flex;align-items:center;justify-content: flex-end" :span="12">
          <div @click="addOfEdit(true)" class="select_xin">新增</div>
        </el-col>
      </el-row>
      <div class="tableDiv">
        <div class="tableDiv_div">
          <el-table

              :data="tableData"
              style="width: 100%">
            <el-table-column
                min-width="120"
                type="index"
                prop="id"
                label="字典类型编号"
            >
            </el-table-column>
            <el-table-column
                min-width="120"
                prop="dictType"
                label="字典类型标签"
            >
            </el-table-column>
            <el-table-column
                prop="dictLabel"
                label="字典名称"
            >
            </el-table-column>
            <el-table-column
                prop="dictValue"
                label="字典键值"
            >
            </el-table-column>
            <el-table-column
                prop="dictSort"
                label="字典排序"
            >
            </el-table-column>
            <el-table-column
                prop="status"
                width="150"
                label="状态"
            >
              <template slot-scope="scope">
                <el-switch
                    @change="val=>customers_groupStatus(val,scope.row.id)"
                    :active-value="1"
                    :inactive-value="0"
                    v-model="scope.row.status"
                    active-text="正常"
                    inactive-text="停用">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column
                prop="createBy"
                label="创建者"
            >
            </el-table-column>
            <el-table-column
                prop="createTime"
                label="创建时间"
            >
            </el-table-column>
            <el-table-column
                prop="updateBy"
                label="更新者"
            >
            </el-table-column>
            <el-table-column
                prop="updateTime"
                label="更新时间"
            >
            </el-table-column>
            <el-table-column
                label="操作"
                width="150"
            >
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="warning"
                    @click="addOfEdit(false, scope.row)">编辑
                </el-button>
                <el-popover
                    style="margin-left: 10px"
                    placement="top"
                    width="160"
                    v-model="scope.row.tanshan">
                  <p>确定删除该数据字典吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="scope.row.tanshan = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="customers_groupDel(scope.row.id,scope.row.tanshan)">
                      确定
                    </el-button>
                  </div>
                  <el-button
                      slot="reference"
                      size="mini"
                      type="danger">删除
                  </el-button>
                </el-popover>

              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
            background
            style="margin-top: 30px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-size="20"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="tanStatus?'添加数据字典':'修改数据字典'" :visible.sync="dialogFormVisible">
      <el-form ref="ruleForm" :rules="rules" :model="ruleForm">
        <el-form-item prop="dictLabel" label="字典名称" label-width="120px">
          <el-input style="width: 50%" v-model="ruleForm.dictLabel" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="dictValue" label="字典键值" label-width="120px">
          <el-input style="width: 50%" type="number" v-model="ruleForm.dictValue" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="dictSort" label="字典排序" label-width="120px">
          <el-input style="width: 50%" type="number" v-model="ruleForm.dictSort" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item style="margin-left:100px;">
          <el-button @click="addSubmit('ruleForm')">确认</el-button>
          <el-button type="primary" @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {httpList} from "@/components/request";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "DictionariesList",
  components: {
  },
  data() {
    return {
      dialogFormVisible: false,
      tanStatus: true,
      searchForm: {
        dictType: "",
      },
      ruleForm: {
        id: 0,
        dictType: "",
        dictLabel: "",
        dictValue: "",
        dictSort: "",
        createBy: "",
      },
      rules: {
        dictType: [
          {required: true, message: '请输入字典类型标签', trigger: 'blur'}
        ],
        dictLabel: [
          {required: true, message: '请输入字典名称', trigger: 'blur'}
        ],
        dictValue: [
          {required: true, message: '请输入字典键值', trigger: 'blur'}
        ],
        dictSort: [
          {required: true, message: '请输入字典排序', trigger: 'blur'}
        ],
        createBy: [
          {required: true, message: '请输入创建者', trigger: 'blur'}
        ],
      },
      total: 0,
      currentPage4: 1,
      tableData: [],
    }
  },
  mounted() {

// “id”: 字典类型id,
// “dictType”: 字典类型标签,
// “dictLabel”: 字典名称,
// “dictValue”: 字典键值,
// “dictSort”: 字典排序,
// “status”: 状态（0停用 1正常）,
// “createBy”: 创建者,
// “createTime”: 创建时间,
// “updateBy”: 更新者,
// “updateTime”: 更新时间

    // dictType:字典类型标签
    // dictLabel:字典名称
    // dictValue:字典键值
    // dictSort:字典排序
    // createBy:创建者
    this.searchForm.dictType = this.$route.params.dictType;
    this.customers_group();
  },
  methods: {
    addOfEdit(type, data) {
      this.tanStatus = type;
      if (type) {
        this.ruleForm = {
          id: 0,
          dictType: "",
          dictLabel: "",
          dictValue: "",
          dictSort: "",
          createBy: "",
        }
      } else {
        this.ruleForm.id = data.id;
        this.ruleForm.dictType = data.dictType;
        this.ruleForm.dictLabel = data.dictLabel;
        this.ruleForm.dictValue = data.dictValue;
        this.ruleForm.dictSort = data.dictSort;
        this.ruleForm.createBy = data.createBy;
      }
      this.dialogFormVisible = true;
    },
    customers_group() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let data = new FormData();
      data.append('pageNo', this.currentPage4);
      data.append('pageSize', 20);
      data.append('dictType', this.searchForm.dictType);
      // data.append('status', this.searchForm.status);
      this.axios
          .post(this.$urlHttp + `/sysDictData/list`, data)
          .then((response) => {
            console.log('sysDictData/list', response.data);
            loading.close();
            if (response.data.code === 200) {
              this.tableData = response.data.data;
              this.total = response.data.total;
              this.current_page = response.data.current_page;
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    customers_groupAdd() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let user = JSON.parse(sessionStorage.getItem('user'));
      let data = new FormData();
      data.append('dictType', this.searchForm.dictType);
      data.append('dictLabel', this.ruleForm.dictLabel);
      data.append('dictValue', this.ruleForm.dictValue);
      data.append('dictSort', this.ruleForm.dictSort);
      data.append('createBy', user.userName);
      this.axios
          .post(this.$urlHttp + `/sysDictData/add`, data)
          .then((response) => {
            loading.close();
            console.log('sysDictData/add', response.data);
            if (response.data.code === 200) {
              this.dialogFormVisible = false;
              this.customers_group();
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    customers_groupEdit() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let user = JSON.parse(sessionStorage.getItem('user'));
      let data = new FormData();
      data.append('id', this.ruleForm.id);
      data.append('dictType', this.searchForm.dictType);
      data.append('dictLabel', this.ruleForm.dictLabel);
      data.append('dictValue', this.ruleForm.dictValue);
      data.append('dictSort', this.ruleForm.dictSort);
      data.append('createBy', user.userName);
      this.axios
          .post(this.$urlHttp + `/sysDictData/edit`, data)
          .then((response) => {
            loading.close();
            console.log('sysDictData/edit', response.data);
            if (response.data.code === 200) {
              this.dialogFormVisible = false;
              this.customers_group();
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    customers_groupDel(id) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.axios
          .delete(this.$urlHttp + `/sysDictData/del?id=${id}`)
          .then((response) => {
            loading.close();
            console.log('sysDictData/del', response.data);
            this.$message(response.data.message);
            if (response.data.code === 200) {
              this.customers_group();
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    customers_groupStatus(status,id) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let user = JSON.parse(sessionStorage.getItem('user'));
      let data = new FormData();
      data.append('id', id);
      data.append('status', status);
      data.append('updateBy', user.userName);
      this.axios
          .post(this.$urlHttp + `/sysDictData/status`, data)
          .then((response) => {
            loading.close();
            console.log('sysDictData/status', response.data);
            this.$message(response.data.message);
            if (response.data.code === 200) {
              // this.dialogFormVisible = false;
              this.customers_group();
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    addSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.tanStatus) {
            this.customers_groupAdd();
          } else {
            this.customers_groupEdit();
          }
          // this.submit();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      console.log(123, formName)
      this.$refs.ruleForm.resetFields();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage4 = val;
      this.customers_group();
    },
  },
}
</script>

<style scoped>
.content >>> .el-dialog__title {
  color: #FFFFFF;
}

.content >>> .el-dialog__headerbtn .el-dialog__close {
  color: #FFFFFF;
}

.content >>> .el-dialog__header {
  background-color: #4696C8;
}

.ButtonDao {
  background-color: #5BC0DE;
  border: none;
}



.tableDiv >>> .el-table th.el-table__cell {
  color: #0358DD;
}

.tableDiv >>> .el-table .warning-row {
  background: #D6EFFF;
}

.tableDiv >>> .el-table .success-row {
  background: #F3FAFF;
}

.tableDiv_div {
  flex: 1;
  overflow: hidden;
  overflow-y: auto;
  display: flex;
}

.tableDiv {
  overflow: hidden;
  flex: 1;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}

.ButtonDao_div {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
}

.listTitle_div {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.listTitle {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.list {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid #D0D0D0;
  border-radius: 6px;
  background-color: #FFFFFF;
  padding: 15px 10px;
  box-sizing: border-box;
}

.content {
  height: 100%;
  padding: 26px 37px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
</style>
